<template>
  <div class="mx-3">
    <Toast />
    <div class="card">
      <Toolbar class="mb-4">
        <template #start>
          <Button label="New" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
        </template>

        <template #end>
          <Button label="Export" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)" />
        </template>
      </Toolbar>

      <DataTable ref="dt" :value="users" dataKey="id" :paginator="true" :rows="10" :filters="filters"
        class="p-datatable-lg"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
        responsiveLayout="scroll">
        <template #header>
          <div class="row py-5">
            <div   v-for="(item, index) in StatusesWithCountUsers" :key="index" @click="filterByStatus(item.id)"  class="status_item col-xl-3 col-sm-6 mb-xl-0 mb-4 py-3" :class="[filters.status_id === item.id ? 'active' : '']">
              <div class="card">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="col-12">
                      <div class="numbers">
                        <p class=" mb-0 text-uppercase font-weight-bold text-center justify-content-center align-content-center fs-3 ">{{ item.name }}</p>
                        <h5 class="font-weight-bolder text-center justify-content-center align-content-center fs-2">
                          {{ item.users_count }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div class="
                table-header
                flex flex-column
                md:flex-row md:justiify-content-between
              ">

         




            <h5 class="mb-2 md:m-0 p-as-md-center">Manage Users</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" placeholder="Search..." />
            </span>
          </div>
        </template>
        <Column class="px-5" field="id" header="Id" :sortable="true" style="min-width: 8rem"></Column>
        <Column header="Name / Phone">

          <template #body="{ data }">
            <div> <img :src="data.image" :alt="data.name" width="60" height="50" /></div>
            <div>

              {{ data.name }} <br> {{ data.phone }}
            </div>
          </template>
        </Column>

        <!-- <Column
          class="px-5"
          field="name"
          header="Name"
          :sortable="true"
          style="min-width: 8rem"
        ></Column>
        <Column
          field="phone"
          header="Phone"
          :sortable="true"
          style="min-width: 9rem"
        ></Column> -->
        <Column field="email" header="Email" :sortable="true" style="min-width: 9rem"></Column>

        <Column header="Statuses" :exportable="false" style="min-width: 12rem">
          <template #body="data">
            <Button label="View Statuses" class="p-button-outlined" @click="viewStatuses(data.data)" />
          </template>
        </Column>
        <Column :exportable="false" field="verified_code" header="Verify Code" bodyClass="text-center"
          style="min-width: 8rem">
          <template #body="{ data }">
            <h6 class="mt-4 text-black-50" v-if="data.verified_code != null"> {{ data.verified_code }}</h6>
            <i class="pi" :class="{
              'true-icon pi-check-circle text-success':
                data.verified_code == null,
            }"></i>
          </template>
          <!--          <template #body="{ data }">-->
          <!--            <i-->
          <!--              class="pi"-->
          <!--              :class="{-->
          <!--                'true-icon pi-check-circle text-success':-->
          <!--                  data.verified_code == null,-->
          <!--                'false-icon pi-times-circle text-danger':-->
          <!--                  data.verified_code != null,-->
          <!--              }"-->
          <!--            ></i>-->
          <!--          </template>-->
        </Column>
        <Column :exportable="false" style="min-width: 8rem">
          <template #body="data">
            <Button label="View Pages" class="p-button-outlined" @click="viewPages(data.data)" />
          </template>
        </Column>
        <Column :exportable="false" style="min-width: 8rem">
          <template #body="data">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mx-1 mr-2"
              @click="editUser(data.data)" />
            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-1"
              @click="confirmDeleteUser(data.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog v-model:visible="UserAddDialog" :style="{ width: '450px', zIndex: 11100 }" header="Add User" :modal="true"
      class="p-fluid">
      <img :src="user.image" :alt="user.name" v-if="user.image" width="100" height="100" class="center" />
      <div class="field">
        <label for="name">Name</label>
        <InputText id="name" v-model.trim="user.name" required="true" autofocus
          :class="{ 'p-invalid': submitted && !user.name }" />
        <small class="p-error" v-if="submitted && !user.name">Name is required.</small>
      </div>
      <div class="field">
        <label for="phone">Phone</label>
        <InputText id="phone" v-model.trim="user.phone" required="true" autofocus
          :class="{ 'p-invalid': submitted && !user.phone }" />
        <small class="p-error" v-if="submitted && !user.phone">Email is required.</small>
      </div>
      <div class="field">
        <label for="email">Email</label>
        <InputText id="email" v-model.trim="user.email" required="true" autofocus
          :class="{ 'p-invalid': submitted && !user.email }" />
        <small class="p-error" v-if="submitted && !user.email">Email is required.</small>
      </div>
      <div class="field">
        <label for="password">Password</label>
        <InputText id="password" v-model.trim="user.password" required="true" autofocus
          :class="{ 'p-invalid': submitted && !user.password }" />
        <small class="p-error" v-if="submitted && !user.password">Password is required.</small>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveUser(user)" />
      </template>
    </Dialog>

    <Dialog v-model:visible="pageEditSubscribtionDialog" :style="{ width: '450px', zIndex: 11100 }"
    header="Add subscribtion " :modal="true" class="p-fluid">


    <div class="field">
      <label for="ApiTokenInstance">Select subscription</label>
      <div v-for="subscription of subscriptions" :key="subscription.id" class="field-radiobutton">
        <RadioButton :inputId="subscription.id" name="subscription_id" :value="subscription.id"
          v-model="subscriptions_data.subscription_id" />
        <label :for="subscription.id">{{ subscription.name }}</label>
      </div>

      <small class="p-error" v-if="submitted && !subscriptions_data.subscription_id">Subscription is required.</small>
    </div>

    <div class="field">
      <label for="SubExpireDate">Select Month Expired Date</label>
      <br>
        <RadioButton  name="sub_expire_date" :value="1"
          v-model="subscriptions_data.sub_expire_date" :inputId="one_month" />
        <label :for="one_month">One Month</label>
      </div>
      <div class="field">

        <RadioButton  name="sub_expire_date" :value="12"
          v-model="subscriptions_data.sub_expire_date"  :inputId="year" />
        <label :for="year">One Year</label>

    </div>

    <template #footer>
      <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
      <Button label="Edit" icon="pi pi-check" class="p-button-text"
        @click="EditSubscriptions_data(subscriptions_data)" />
    </template>
  </Dialog>



    <Dialog v-model:visible="WhatsappAccountAddDialog" :style="{ width: '450px', zIndex: 11100 }"
      header="Add WhatsApp Account" :modal="true" class="p-fluid">

      <div class="field">
        <label for="ApiTokenInstance">Select Page</label>
        <div v-for="page of userPages.data" :key="page.id" class="field-radiobutton">
          <RadioButton :inputId="page.id" name="page_id" :value="page.id" v-model="whatsapp_account.page_id" />
          <label :for="page.id">{{ page.name }}</label>
        </div>
        <div class="field-radiobutton">
          <RadioButton :inputId="'new_page'" name="page_id" :value="'new_page'" v-model="whatsapp_account.page_id" />
          <label :for="'new_page'">New Page</label>
        </div>

        <small class="p-error" v-if="submitted && !whatsapp_account.page_id">Page is required.</small>
      </div>
      <div class="field" v-if="whatsapp_account.page_id == 'new_page'">
        <label for="name">Name</label>
        <InputText id="name" v-model.trim="whatsapp_account.name" required="true" autofocus
          :class="{ 'p-invalid': submitted && !whatsapp_account.name }" />
        <small class="p-error" v-if="submitted && !whatsapp_account.name">Name is required.</small>
      </div>
      <div class="field">
        <label for="phone">Phone</label>
        <InputText id="phone" v-model.trim="whatsapp_account.phone" required="true" autofocus
          :class="{ 'p-invalid': submitted && !whatsapp_account.phone }" />
        <small class="p-error" v-if="submitted && !whatsapp_account.phone">Phone is required.</small>
      </div>
      <div class="field">
        <label for="idInstance">idInstance</label>
        <InputText id="idInstance" v-model.trim="whatsapp_account.idInstance" required="true" autofocus
          :class="{ 'p-invalid': submitted && !whatsapp_account.idInstance }" />
        <small class="p-error" v-if="submitted && !whatsapp_account.idInstance">idInstance is required.</small>
      </div>

      <div class="field">
        <label for="ApiTokenInstance">ApiTokenInstance</label>
        <InputText id="ApiTokenInstance" v-model.trim="whatsapp_account.ApiTokenInstance" required="true" autofocus
          :class="{ 'p-invalid': submitted && !whatsapp_account.ApiTokenInstance }" />
        <small class="p-error" v-if="submitted && !whatsapp_account.ApiTokenInstance">ApiTokenInstance is
          required.</small>
      </div>
      <div class="field">
        <label for="ApiTokenInstance">Select subscription</label>
        <div v-for="subscription of subscriptions" :key="subscription.id" class="field-radiobutton">
          <RadioButton :inputId="subscription.id" name="subscription_id" :value="subscription.id"
            v-model="whatsapp_account.subscription_id" />
          <label :for="subscription.id">{{ subscription.name }}</label>
        </div>

        <small class="p-error" v-if="submitted && !whatsapp_account.subscription_id">Subscription is required.</small>
      </div>

      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" v-if="!whatsapp_account_edit" icon="pi pi-check" class="p-button-text"
          @click="saveWhatsapp_acc(whatsapp_account)" />
        <Button label="Edit" v-if="whatsapp_account_edit" icon="pi pi-check" class="p-button-text"
          @click="EditWhatsapp_acc(whatsapp_account)" />
      </template>
    </Dialog>
    <Dialog v-model:visible="userStatusAddDialog" :style="{ width: '450px', zIndex: 11100 }" header="Add Status to User"
      :modal="true" class="p-fluid">

      <div class="field">
        <label for="comment">Comment</label>
        <Dropdown v-model="user_NewStatus.status_id" :options="statuses" optionLabel="name" optionValue="id"
          placeholder="Select a Status" class="w-full md:w-14rem" />

      </div>

      <div class="field">

        <label for="comment">Comment</label>
        <InputText id="comment" v-model.trim="user_NewStatus.comment" required="true" autofocus />

      </div>


      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" v-if="!userStatus_edit" icon="pi pi-check" class="p-button-text"
          @click="saveUserStatus(user_NewStatus)" />
        <Button label="Edit" v-if="userStatus_edit" icon="pi pi-check" class="p-button-text"
          @click="saveUserStatus(user_NewStatus)" />
      </template>
    </Dialog>

    <Dialog v-model:visible="UserEdiDialog" :style="{ width: '450px', zIndex: 11100 }" header="User Details"
      :modal="true" class="p-fluid">
      <img :src="user.image" :alt="user.name" v-if="user.image" width="400" height="110" class="center px-6" />
      <div class="field">
        <label for="name">Name</label>
        <InputText id="name" v-model.trim="user.name" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !user.name }" />
        <small class="p-error" v-if="submittedEdit && !user.name">Name is required.</small>
      </div>
      <div class="field">
        <label for="phone">Phone</label>
        <InputText id="phone" v-model.trim="user.phone" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !user.phone }" />
        <small class="p-error" v-if="submittedEdit && !user.phone">Email is required.</small>
      </div>
      <div class="field">
        <label for="email">Email</label>
        <InputText id="email" v-model.trim="user.email" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !user.email }" />
        <small class="p-error" v-if="submittedEdit && !user.email">Email is required.</small>
      </div>
      <div class="field">
        <label for="password">Password</label>
        <InputText id="password" v-model.trim="user.password" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !user.password }" />
        <small class="p-error" v-if="submittedEdit && !user.password">Password is required.</small>
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveEditUser(user)" />
      </template>
    </Dialog>

    <Dialog v-model:visible="userPagesDialog" :style="{ width: '1200px' }" header="User Pages" :modal="true"
      class="p-fluid">
      <Button label="Add new WhatsApp Account" icon="pi pi-plus" class="p-button-success mr-2" @click="openNewWhatsapp" />

      <DataTable :value="this.userPages.data" responsiveLayout="scroll" dataKey="id">
        <Column field="id" header="Id"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="dashboard_role.role_name" header="Role"></Column>
        <Column field="subscription.name" header="Subscription"></Column>
        <Column field="sub_expire_date" header="Expire At"></Column>
        <Column field="contacts_count" header="Contacts"></Column>
        <Column field="users_count" header="Users"></Column>
        <Column field="sub_expired" header="Expired"></Column>
        <Column field="limit_contacts" header="Contact Limit"></Column>
        <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button v-if="data.data.whatsapp != null" label="Edit Whatsapp" class="p-button-outlined"
              @click="EditWhatsapp(data.data.whatsapp, data.data.subscription_id)" />
          </template>
        </Column>

        <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button label="Edit Subscribtion" class="p-button-outlined" @click="openSubscribeDialog(data.data)" />

          </template>
        </Column>

        <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button label="View Users" class="p-button-outlined" @click="viewUsers(data.data.id)" />
          </template>
        </Column>

      </DataTable>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog('userPagesDialog')" />
      </template>
    </Dialog>
    <Dialog v-model:visible="userStatusDialog" :style="{ width: '1200px' }" header="User Status" :modal="true"
      class="p-fluid">
      <Button label="Add new Status" icon="pi pi-plus" class="p-button-success mr-2" @click="openNewStatus" />

      <DataTable :value="this.userStatuses" responsiveLayout="scroll" dataKey="id">
        <Column field="id" header="Id"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="comment" header="Comment"></Column>
        <Column field="created_at" header="Created At"></Column>
        <Column field="created_by" header="Created By"></Column>


      </DataTable>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog('userStatusDialog')" />
      </template>
    </Dialog>

    <Dialog v-model:visible="PageUsersDialog" :style="{ width: '1200px' }" header="Users" :modal="true" class="p-fluid">
      <DataTable :value="this.pageUsers" responsiveLayout="scroll" dataKey="id">
        <Column field="id" header="Id"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="email" header="Email"></Column>
        <Column field="phone" header="Phone"></Column>
      </DataTable>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideUsers" />
      </template>

    </Dialog>
    <Dialog v-model:visible="deleteUser" :style="{ width: '450px', zIndex: 11100 }" header="Confirm" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mx-3 text-warning" style="font-size: 3rem" />
        <span v-if="user"> Are you sure you want to delete <b>{{ user.name }}</b> ?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUser = false" />
        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="removeUser(user.id)" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import UserService from "./service/UserService";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Dialog from "primevue/dialog";
import Toast from 'primevue/toast';
import InputText from "primevue/inputtext";
import RadioButton from 'primevue/radiobutton';
import subscriptionService from "./service/SubscriptionService";
import Dropdown from 'primevue/dropdown';


export default {
  components: {
    DataTable: DataTable,
    Column: Column,
    Button: Button,
    Dialog: Dialog,
    Toolbar: Toolbar,
    InputText: InputText,
    RadioButton: RadioButton,
    Toast,
    Dropdown,

    // InputNumber
  },
  data() {
    return {
      users: null,
      statuses: [],
      StatusesWithCountUsers: [],
      subscriptions: null,
      UserAddDialog: false,
      deleteUser: false,
      WhatsappAccountAddDialog: false,
      pageEditSubscribtionDialog: false,
      user: {},
      whatsapp_account: {},
      subscriptions_data:{},
      user_NewStatus: {},
      userStatusAddDialog: false,
      userStatus_edit: false,
      filters: {},
      submitted: false,
      UserEdiDialog: false,
      submittedEdit: false,
      whatsapp_account_edit: false,
      userPages: null,
      userPagesDialog: false,
      userStatusDialog: false,
      userStatuses: null,
      pageUsers: null,
      user_id: null,
      user_is_open: null,
      PageUsersDialog: false,
      // username : null 
    };
  },
  userService: null,
  created() {
    this.subscriptionService = new subscriptionService();
    this.userService = new UserService();
    this.initFilters();
  },
  mounted() {
    this.userService.getUsers().then((data) => {
      console.log(data);
      this.users = data.data;
    });
    this.userService.getStatuses().then((data) => {
      this.statuses = data.data;
    });
    this.userService.getStatusesWithCountUsers().then((data) => {
      this.StatusesWithCountUsers = data.data;
    });

    this.subscriptionService.getSubscriptions().then((data) => {
      this.subscriptions = data.data;
    });
  },
  methods: {
    openNewWhatsapp() {
      console.log('openNewWhatsapp');
      this.whatsapp_account = {};
      this.whatsapp_account.user_id = this.user_id;
      this.WhatsappAccountAddDialog = true;
      this.whatsapp_account_edit = false;
    },
    openSubscribeDialog(page) {
      console.log(page);
      this.subscriptions_data = {};
      this.subscriptions_data.page_id = page.id;
      this.subscriptions_data.subscription_id = page.subscription_id;
      this.pageEditSubscribtionDialog = true;
    },

    
    openNewStatus() {
      console.log('openNewStatus');
      this.user_NewStatus = {};
      this.user_NewStatus.user_id = this.user_id;
      this.userStatusAddDialog = true;
      this.userStatus_edit = false;
    },
    openNew() {
      this.user = {};
      this.UserAddDialog = true;
    },

    hideDialog(type = null) {
      this.UserAddDialog = false;
      this.whatsapp_account_edit = false;
      this.userStatus_edit = false;
      this.WhatsappAccountAddDialog = false;
      this.userStatusAddDialog = false;
      this.whatsapp_account = {};
      this.user = {};
      this.subscriptions_data={};
      this.submitted = false;
      this.UserEdiDialog = false;
      this.submittedEdit = false;
      this.pageEditSubscribtionDialog = false;
      if (type == "userPagesDialog") {

        this.userPagesDialog = false
      }
      if (type == "userStatusDialog") {

        this.userStatusDialog = false
      }


    },
    hideUsers() {
      this.PageUsersDialog = false
    },
    saveUser(user) {
      this.submitted = true;
      console.log(user)
      if (user.email && user.name && user.phone && user.password) {
        this.userService.addUser(user).then((data) => {
          this.submitted = false;
          this.users.push(data.data);
          this.UserAddDialog = false;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "User Added",
            life: 3000,
          });
        });
      }
    },
    saveWhatsapp_acc(whatsapp_account) {
      this.submitted = true;
      console.log(whatsapp_account)

      if (whatsapp_account.page_id && whatsapp_account.phone && whatsapp_account.user_id && whatsapp_account.subscription_id && whatsapp_account.idInstance && whatsapp_account.ApiTokenInstance) {
        this.userService.addwhatsappAccount(whatsapp_account).then((data) => {
          console.log(data);
          this.submitted = false;
          if (data.status == "error") {
            if (data.data.response.status == 422) {
              for (let ob_error in data.data.response.data.errors) {
                console.log(`${ob_error}: ${data.data.response.data.errors[ob_error]}`);

                // code block to be executed
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: data.data.response.data.errors[ob_error][0],
                  life: 3000,
                });
              }

            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Invalid Data",
                life: 3000,
              });
            }
          } else {
            this.WhatsappAccountAddDialog = false;
            this.Subscribtion = false;
            this.whatsapp_account_edit = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "WhatsApp Account Added",
              life: 3000,
            });
            this.viewPages(this.user_is_open);
          }

        });
      }
    },
    saveUserStatus(user_NewStatus) {
      this.submitted = true;
      console.log(user_NewStatus)

      if (user_NewStatus.user_id && user_NewStatus.status_id) {
        this.userService.addStatus(user_NewStatus).then((data) => {
          console.log(data);
          this.submitted = false;
          if (data.status == "error") {
            if (data.data.response.status == 422) {
              for (let ob_error in data.data.response.data.errors) {

                // code block to be executed
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: data.data.response.data.errors[ob_error][0],
                  life: 3000,
                });
              }

            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Invalid Data",
                life: 3000,
              });
            }
          } else {
            this.userStatus_edit = false;
            this.userStatusAddDialog = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Status Added",
              life: 3000,
            });
            this.userService.getStatusesWithCountUsers().then((data) => {
              this.StatusesWithCountUsers = data.data;
            });
            this.viewStatuses(this.user_is_open);
          }

        });
      }
    },

    
    EditSubscriptions_data(subscriptions_data) {
      this.submitted = true;
      console.log(subscriptions_data);

      if (subscriptions_data.page_id && subscriptions_data.subscription_id ) {
        this.userService.EditSubscriptionsPage(subscriptions_data).then((data) => {
          console.log(data);
          this.submitted = false;
          if (data.status == "error") {
            if (data.data.response.status == 422) {
              for (let ob_error in data.data.response.data.errors) {
                console.log(`${ob_error}: ${data.data.response.data.errors[ob_error]}`);

                // code block to be executed
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: data.data.response.data.errors[ob_error][0],
                  life: 3000,
                });
              }

            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Invalid Data",
                life: 3000,
              });
            }
          } else {
            this.pageEditSubscribtionDialog = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Subscribtion Edit Successfully",
              life: 3000,
            });
            this.viewPages(this.user_is_open);
          }

        });
      }
    },

    EditWhatsapp_acc(whatsapp_account) {
      this.submitted = true;
      console.log(whatsapp_account);




      if (whatsapp_account.page_id && whatsapp_account.phone && whatsapp_account.user_id && whatsapp_account.subscription_id && whatsapp_account.idInstance && whatsapp_account.ApiTokenInstance) {
        this.userService.EditwhatsappAccount(whatsapp_account).then((data) => {
          console.log(data);
          this.submitted = false;
          if (data.status == "error") {
            if (data.data.response.status == 422) {
              for (let ob_error in data.data.response.data.errors) {
                console.log(`${ob_error}: ${data.data.response.data.errors[ob_error]}`);

                // code block to be executed
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: data.data.response.data.errors[ob_error][0],
                  life: 3000,
                });
              }

            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Invalid Data",
                life: 3000,
              });
            }
          } else {
            this.WhatsappAccountAddDialog = false;
            this.Subscribtion = false;
            this.whatsapp_account_edit = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "WhatsApp Account Edited",
              life: 3000,
            });
            this.viewPages(this.user_is_open);
          }

        });
      }
    },
    EditWhatsapp(whatsapp_account, subscription_id) {
      this.whatsapp_account = { ...whatsapp_account, 'subscription_id': subscription_id };
      this.whatsapp_account_edit = true;
      this.WhatsappAccountAddDialog = true;
      this.whatsapp_account.user_id = this.user_id;

    },
   
    
    editUser(user) {
      this.user = { ...user };
      this.UserEdiDialog = true;
    },
    saveEditUser(user) {
      this.submittedEdit = true;
      if (user.email && user.name && user.phone && user.password) {
        this.userService.EditUser(user).then((data) => {
          this.users = this.users.filter(function (user) {
            if (user.id == data.data.id) {
              user.name = data.data.name;
              user.phone = data.data.phone;
              user.email = data.data.email;
            }
            return user;
          })
          this.UserEdiDialog = false;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "User Updated",
            life: 3000,
          });
        });
      }
    },
    confirmDeleteUser(user) {
      this.user = user;
      this.deleteUser = true;
    },
    removeUser(userId) {
      this.userService.RemoveUser(userId).then(() => {
        this.users = this.users.filter(user => user.id != userId);
        this.deleteUser = false;
        this.$toast.add({
          severity: "warn",
          summary: "Successful",
          detail: "User Deleted",
          life: 3000,
        });
      });
    },
    viewPages(user) {
      // this.username = user.name ;
      // console.log(this.username)
      this.userService.UserPages(user.id).then((data) => {
        this.userPages = data.data;
        this.user_is_open = user;
        this.user_id = user.id;
        this.userPagesDialog = true;

      })
    },

    viewStatuses(user) {
      // this.username = user.name ;
      // console.log(this.username)
      this.userService.UserStatuses(user.id).then((data) => {
        this.userStatuses = data.data;
        this.user_is_open = user;
        this.user_id = user.id;
        this.userStatusDialog = true;

      })
    },

    viewUsers(pageId) {
      // console.log(pageId)
      this.userService.pageUsers(pageId).then((data) => {
        this.pageUsers = data.data.data.all_users;
        this.PageUsersDialog = true;
      })
    },

    filterByStatus(status_id){

      if(this.filters.status_id === status_id ){
        console.log('old');
        this.filters.status_id = '';
        this.userService.getUsers().then((data) => {
          console.log(data);
          this.users = data.data;
        });
      }else{

        this.filters.status_id = status_id;
        this.userService.getUsersByStatus(status_id).then((data) => {
          this.users = data.data;
        });
      }
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    align-items: start;
  }
}

.p-dialog .product-image {
  width: 50px;
  margin: 0 auto 2rem auto;
  display: block;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status_item .card{
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.status_item:hover .card {
  background-color: #ddd;
}

.status_item.active .card {
  background-color: #27ae60;
  color: #ecf0f1;
}



@media screen and (max-width: 960px) {
  ::v-deep(.p-toolbar) {
    flex-wrap: wrap;

    .p-button {
      margin-bottom: 0.25rem;
    }
  }
}
</style>